<template>
    <div class="transformer-manage">
        <div style="margin-bottom: 20px;">
            <!-- <el-button class="leader-common-button" @click="addNewData">新增</el-button> -->
            <el-form
                :label-position="'left'"
                :model="searchForm"
                ref="searchForm"
                class="leader-style-form"
                :inline="true"
            >
                <el-form-item label="公司名" label-width="50px" prop="cust_name">
                    <el-input
                        placeholder="请输入公司名"
                        type="text"
                        class="em_inpunt"
                        oninput="if(value.length>50)value=value.slice(0,50)"
                        clearable
                        v-model="searchForm.cust_name"
                    ></el-input>
                </el-form-item>
                <el-form-item label="变压器名称" label-width="90px" prop="transformer_name">
                    <el-input
                        placeholder="请输入变压器名称"
                        maxlength="20"
                        class="em_inpunt"
                        clearable
                        v-model="searchForm.transformer_name"
                    ></el-input>
                </el-form-item>

                <div style="float: right">
                    <el-button size="medium" type="warning" @click="getTransformerPage">检索</el-button>
                    <el-button type="primary" @click="addNewData" size="medium">新增</el-button>
                </div>
            </el-form>
        </div>
        <div class="table-wrap">
            <el-scrollbar style="height: 90%">
                <el-table border :data="tableData" class="leader-style-table">
                    <el-table-column label="序号" width="50" align="center">
                        <template slot-scope="scope">
                            <span>
                                {{
                                    (pageNum - 1) * pageSize + scope.$index + 1
                                }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="公司名称" prop="cust_name"></el-table-column>
                    <el-table-column label="变压器名称" prop="transformer_name"></el-table-column>
                    <el-table-column label="变压器容量(kVA)" prop="capacity"></el-table-column>
                    <el-table-column label="额定电流(A)" prop="rated_current"></el-table-column>
                    <el-table-column label="对应采集点" prop="point_name"></el-table-column>
                    <el-table-column label="操作" align="center" width="210">
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleEditInfo(scope.row, '修改')">修改</el-button>
                            <el-button type="text" @click="hanleDelInfo(scope.row)">删除</el-button>
                            <el-button type="text"  @click="handleEditInfo(scope.row, '查看')">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-scrollbar>

            <el-pagination
                class="leader-style-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination>
        </div>
        <el-dialog
            class="leader-dialog"
            :title="dialogTitle"
            width="50%"
            :visible.sync="dialogStatus" 
            @close="closeDiaCb"
            :close-on-click-modal="dialogTitle !== '查看' ? false : true"
        >
            <el-form
                :model="formData"
                ref="formData"
                label-width="160px"
                :rules="formDataRule"
                class="leader-style-form"
            >
                <el-form-item label="公司名称" prop="elec_customer_id">
                    <el-select
                        style="width: 100%"
                        v-model="formData.elec_customer_id"
                        :disabled="dialogTitle === '查看'"
                        placeholder="请选择公司"
                        @change="changeCustomer"
                    >
                        <el-option
                            v-for="item in companys"
                            :key="item.elec_customer_id"
                            :label="item.cust_name"
                            :value="item.elec_customer_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="变压器名称" prop="transformer_name">
                    <el-input
                        v-model="formData.transformer_name"
                        maxlength="20"
                        placeholder="请输入变压器"
                        :disabled="dialogTitle === '查看'"
                    ></el-input>
                </el-form-item>
                <el-form-item label="变压器容量(kVA)" prop="capacity">
                    <el-input
                        v-model="formData.capacity"
                        oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                        placeholder="请输入变压器容量"
                        maxlength="20"
                        :disabled="dialogTitle === '查看'"
                    ></el-input>
                </el-form-item>
                <el-form-item label="额定电流(A)" prop="rated_current">
                    <el-input
                        v-model="formData.rated_current"
                        maxlength="20"
                        placeholder="请输入额定电流"
                        v-Int.float
                        :disabled="dialogTitle === '查看'"
                    ></el-input>
                </el-form-item>
                <el-form-item label="对应采集点" prop="point_id">
                    <el-select
                        style="width: 100%"
                        v-model="formData.point_id"
                        :disabled="dialogTitle === '查看'"
                        placeholder="请选择对应采集点"
                        @focus="changePoint"
                    >
                        <el-option
                            v-for="item in pointSelects"
                            :key="item.point_id"
                            :label="item.point_name"
                            :value="item.point_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    class="leader-common-button"
                    @click="addCommit"
                    v-if="dialogTitle != '查看'"
                >保 存</el-button>
                <el-button
                    @click="closeDiaCb()"
                    class="leader-common-button"
                >{{ dialogTitle === "查看" ? "关 闭" : "取 消" }}</el-button> 
            </div>
        </el-dialog>
    </div>
</template>
<script>
import * as api from "@/http/api.js";
export default {
    data() {
        return {
            searchForm: {
                transformer_name: "",
                cust_name: "",
            },
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            tableData: [],
            dialogTitle: "新增",
            dialogStatus: false,
            formData: {
                transformer_id: "",
                elec_customer_id: "",
                transformer_name: "",
                capacity: "",
                rated_current: "",
                point_id: ""
            },
            formDataRule: {
                elec_customer_id: [
                    {
                        required: true,
                        message: "请选择公司",
                        trigger: "change"
                    }
                ],
                transformer_name: [
                    {
                        required: true,
                        message: "请输入变压器",
                        trigger: "blur"
                    }
                ],
                capacity: [
                    {
                        required: true,
                        message: "请输入额定容量 ",
                        trigger: "blur"
                    }
                ],
                rated_current: [
                    {
                        required: true,
                        message: "请输入额定电流",
                        trigger: "blur"
                    }
                ],
                point_id: [
                    {
                        required: true,
                        message: "请选择对应采集点",
                        trigger: "change"
                    }
                ]
            },
            companys: [], //公司列表
            pointSelects: []
        };
    },
    created() {
        this.getCustomerList();

        this.getTransformerPage();
    },
    methods: {
        // 获取变压器列表
        getTransformerPage() {
            api.getTransformerPage({
                ...this.searchForm,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }).then(res => {
                if (res && res.error_code === "0") {
                    {
                        this.tableData = res.bus_json.items;
                        this.totalNum = res.bus_json.totalNum;
                    }
                }
            });
        },
        /**
         * 列表条数改变回调
         */
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getTransformerPage();
        },
        /**
         * 企业列表页码改变回调
         */
        handleCurrentChange(e) {
            this.pageNum = e;
            this.getTransformerPage();
        },
        addNewData() {
            this.dialogTitle = "新增";
            this.dialogStatus = true;
            this.formData.transformer_id = "";
            this.formData.elec_customer_id = "";
            this.formData.transformer_name = "";
            this.formData.capacity = "";
            this.formData.rated_current = "";
            this.formData.point_id = "";
            this.pointSelects = [];
        },
        handleEditInfo(row, title) {
            this.dialogStatus = true;
            this.dialogTitle = title;
            this.formData = { ...row };
            this.getTransformerPointList(row.elec_customer_id);
            
        },
        // 获取公司列表
        getCustomerList() {
            api.getCustomerList().then(res => {
                if (res && res.error_code === "0") {
                    this.companys = res.bus_json;
                }
            });
        },
        changeCustomer(elec_customer_id) {
            this.formData.point_id = "";
            this.getTransformerPointList(elec_customer_id);
        },
        // 获取对应采集点列表
        getTransformerPointList(elec_customer_id) {
            api.getTransformerPointList({ elec_customer_id }).then(res => {
                if (res && res.error_code === "0") {
                    this.pointSelects = res.bus_json;
                }
            });
        },
        changePoint(val) {
            if (this.formData.elec_customer_id == "") {
                this.$message({
                    message: "请先选择公司",
                    type: "warning"
                });
            }
        },
        // 变压器容量输入监听
        capacityInput(value) {
            console.log("capacityInput: ", val);
            value = value
                .replace(/[^\d.]/g, "")
                .replace(/\.{2,}/g, ".")
                .replace(".", "$#$")
                .replace(/\./g, "")
                .replace("$#$", ".")
                .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3")
                .replace(/^\./g, "");
        },
        addCommit() {
            this.$refs["formData"].validate(valid => {
                if (valid) {
                    api.saveTransformer({ ...this.formData }).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.getTransformerPage();
                            this.dialogStatus = false;
                        }
                    });
                }
            });
        },
        hanleDelInfo(row) {
            this.$confirm("确定删除这条数据吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(_ => {
                api.deleteTransformer({
                    transformer_id: row.transformer_id
                }).then(res => {
                    if (res && res.error_code === "0") {
                        // 最后一页，只有一条数据时，点击删除
                        if (
                            this.totalNum -
                            (this.pageNum - 1) * this.pageSize ==
                            1
                        ) {
                            // 处理页码显示问题
                            this.pageNum =
                                this.pageNum == 1
                                    ? this.pageNum
                                    : this.pageNum - 1;
                        }
                        this.getTransformerPage();
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                    }
                });
            });
        },
        closeDiaCb() {
            this.dialogStatus = false;
            this.$refs.formData.resetFields();
        }
    }
};
</script>
<style lang="scss">
.transformer-manage {
    width: 100%;
    height: 100%;
    padding: px2Rem(20px);
    box-sizing: border-box;
}
</style>
